// extracted by css-extract-rspack-plugin
export default {"cls1":"CitationOutput-cls1_OJs","cls2":"CitationOutput-cls2_EOJ CitationOutput-cls1_OJs"};